import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { AppDispatch } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { checkGetProperty } from './STR';
import moment from 'moment';

export const updateUserAccessMessage = ({ status, dispatch }: { status: number; dispatch: AppDispatch }) => {
  if (status === 401) {
    dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
  } else if (status === 403) {
    dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
  } else {
    dispatch(setSnackbarMessage(`${status} : Internal Server Error`, 'error'));
  }
};

export const updateUserAccess = (error: FetchBaseQueryError | SerializedError | undefined, dispatch: AppDispatch) => {
  if (error) {
    const status = checkGetProperty(error, 'status');
    if (status === 404) {
      console.error(error);
    } else {
      updateUserAccessMessage({ status, dispatch });
    }
  }
};

export const getUTCDateTimeOfNow = () => moment.utc(new Date()).format();

export const convertToMinutes = (durString: string) => {
  const tempArr: string[] = durString.split(' ');
  let totalMinutes = 0;
  for (let i = 0; i < tempArr.length; i += 2) {
    if (tempArr[i + 1] === 'hour' || tempArr[i + 1] === 'hours') {
      totalMinutes += parseInt(tempArr[i]) * 60;
    } else if (tempArr[i + 1] === 'minutes' || tempArr[i + 1] === 'minute') {
      totalMinutes += parseInt(tempArr[i]);
    }
  }
  return totalMinutes;
};

export const getPerformanceTime = (key: string) => {
  return (profilerId: any, mode: any, actualTime: any, baseTime: any, startTime: any, commitTime: any) => {
    if (mode === 'mode') {
      return;
    }
    window['cmpTimings' as any] = window['cmpTimings' as any] || {};
    window['cmpTimings' as any][key as any] = window['cmpTimings' as any][key as any] || 0;
    window['cmpTimings' as any][key as any] += baseTime;
    console.debug({
      profilerId,
      mode,
      actualTime,
      startTime,
      commitTime
    });
  };
};
